import z from 'zod';

// Model for DesklyConnect settings
export const desklyConnectSettings = z.object({
    active: z.boolean(),
    autoBooking: z.boolean(),
    hotDeskingDisabledForAnyLocation: z.boolean(),
});

export type DesklyConnectSettings = z.infer<typeof desklyConnectSettings>;

// Form model for updating DesklyConnect settings
export const desklyConnectForm = z.object({
    active: z.boolean(),
    autoBooking: z.boolean(),
});

export type DesklyConnectForm = z.infer<typeof desklyConnectForm>;
